
import Vue from "vue";
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {BvTableFieldArray} from "bootstrap-vue";
import {HarbourVisitModel} from "@/api-client";
import {formatDate} from "@/formatting/dateFormatter";
import ButtonWithConfirm from "@/features/shared/components/ButtonWithConfirm.vue";

@Component({
    components: { 
        ButtonWithConfirm
    }
})
export default class HarbourVisitsTable extends Vue {
  @Prop({ required: true })
  value!: HarbourVisitModel[];
  
  @Prop({ default: () => true })
  visitsCanBeRemoved!: boolean;
  
  private removeVisit(visit: HarbourVisitModel) {
    this.$emit('remove', visit);
  }
  
  fields: BvTableFieldArray = [
    { key: 'nr', label: this.$ls.Documents_Practices_Table_HarborVisits_Label_Number, sortable: true, formatter: (value: any, key: any, item: HarbourVisitModel) => {return this.value.indexOf(item) + 1}},
    { key: 'harbourId', label: this.$ls.Documents_Practices_Table_HarborVisits_Label_Harbour, sortable: true, sortByFormatted: true, formatter: (value: string, key: string, item: HarbourVisitModel) => item.harbour?.text },
    { key: 'enteringTimeAndPilot', label: this.$ls.Documents_Practices_Table_HarborVisits_Label_Entry, sortable: false },
    { key: 'exitedTimeAndPilot', label: this.$ls.Documents_Practices_Table_HarborVisits_Label_Exit, sortable: false },
    { key: 'actions', label: '', sortable: false , tdClass: 'table-actions'}
  ];
}
